// extracted by mini-css-extract-plugin
module.exports = {"hero":"home_hero_3mafH","featured":"home_featured_3-LeK","featured__card":"home_featured__card_3ZEy1","websites":"home_websites_225S3","websites__card":"home_websites__card_IXVca"};